function lerp (start, end, amt){
  return (1-amt)*start+amt*end
}

class ScrollEvents {
  constructor() {
    this.scroll = 0;
    this.initialize();
    this.addListeners();
  }

  initialize() {
    this.isMobile = window.outerWidth < 400;
    this.windowPercent = this.isMobile ? 0.3 : 0.2;
    this.main = document.querySelector('.pal-wrapper');
    // Set overflow to 'hidden' so that scrollHeight is the correct value
    this.main.querySelector('main').style.overflow = 'hidden';
    this.footer = document.querySelector('#site-footer');
    this.mainHeight = this.main.getBoundingClientRect().height * 0.8;
    this.contentHeight = this.main.scrollHeight;
    this.threshold = this.contentHeight - window.innerHeight - (window.innerHeight * this.windowPercent);    
    this.logo = document.querySelector('.header__logo');
    this.menuBar = document.querySelector('.sticky-menu__list');
    this.menuButton = document.querySelector('.sticky-menu .menu-button');
    this.isProductPage = window.location.pathname.includes('products') && !window.location.pathname.includes('studio');
    this.isContactPage = window.location.pathname.includes('contact');
    this.isContactPage = window.location.pathname.includes('terms-conditions');
    this.isShopPage = window.location.pathname.includes('collections/shop');
    this.isBlogPage = window.location.pathname.includes('blogs');
    this.lastScrollTop = 0;
    this.topPos = 0;
    
    if(this.mainHeight > window.innerHeight) this.main.querySelector('main').style.transformOrigin = "50% 0";
    if(this.isProductPage || this.isContactPage || this.isTermsPage || this.isShopPage || this.isBlogPage) {
      this.logo.classList.add('reverse')
    }

    if(this.isProductPage && window.innerWidth < 1023) {
      this.menuBar.classList.add('opaque');
      this.menuButton.classList.add('opaque');
    }

    // Set overflow to 'visible' so the sticky events work correctly
    this.main.querySelector('main').style.overflow = 'visible';

    if(this.contentHeight < window.innerHeight) {
      this.footer.classList.add('visible')  
    }
  }

  onScroll() {
    const threshold = this.main.scrollHeight - window.innerHeight - (window.innerHeight * this.windowPercent)
    const scroll = this.main.scrollTop;
    this.scroll = scroll;
    const direction = scroll > this.lastScrollTop ? 'down' : 'up'
    this.lastScrollTop = this.scroll;
    
    if(typeof scrollingCards !== "undefined") scrollingCards.onScroll(scroll);
    if(typeof scrollingImages !== "undefined") scrollingImages.onScroll(scroll);
    typeof studioScroll !== "undefined" && studioScroll.onScroll(scroll);
    typeof terms !== "undefined" && terms.onScroll(scroll);

    if(this.isProductPage && window.innerWidth < 1023) {
      if(scroll < 100) {
        this.menuBar.classList.add('opaque')
        this.menuButton.classList.add('opaque')
      } else {
        this.menuBar.classList.remove('opaque')
        this.menuButton.classList.remove('opaque')
      }
    }

    if(!this.isProductPage && !this.isContactPage && !this.isShopPage && !this.isBlogPage) {
      if(scroll > window.innerHeight) {
        this.logo.classList.add('reverse')
      } else {
        this.logo.classList.remove('reverse')
      }
    }

    if(direction == 'down' && scroll > 1) { 
      this.logo.classList.add('hide')
    } else {
      this.logo.classList.remove('hide')
    }
    
    if(this.contentHeight > window.innerHeight * 2 && scroll > window.innerHeight + this.mainHeight / 2) {
      this.main.querySelector('main').style.transformOrigin = "50% 100%";
    } else {
      this.main.querySelector('main').style.transformOrigin = "50% 0";
    }

    if(scroll > threshold) {
      // this.main.querySelector('main').classList.add('zoomed')
      this.main.querySelector('main').style.overflow = 'hidden';
      gsap.to(this.main.querySelector('[data-main-overlay]'), {
        opacity: 0.05,
        duration: 0.5
      });
      gsap.to(this.main.querySelector('main'), {
        scale: 0.95,
        duration: 0.5,
      });
      this.footer.classList.add('visible')
    } else {
      // this.main.querySelector('main').classList.remove('zoomed')
      this.main.querySelector('main').style.overflow = 'visible';
      gsap.to(this.main.querySelector('main'), {
        scale: 1,
        duration: 0.5,
      });
      gsap.to(this.main.querySelector('[data-main-overlay]'), {
        opacity: 0,
        duration: 0.5
      });
      this.footer.classList.remove('visible')
    }
  }

  getScroll() {
    return this.scroll;
  }

  setScroll(scroll) {
    this.scroll = scroll;
  }

  addListeners() {
    this.initialize();
    this.main.addEventListener('scroll', this.onScroll.bind(this));
    window.addEventListener('resize', this.initialize.bind(this))
  }

  removeListeners() {
    this.main.removeEventListener('scroll', this.onScroll.bind(this));
    window.removeEventListener('resize', this.initialize.bind(this))
  }
}

const scrollEvents = new ScrollEvents();